export const NAV = {
  root: 'main-nav',
  logo: 'nav-logo',
  linkExpertises: 'nav-link-expertises',
  linkReferences: 'nav-link-references',
  linkMethode: 'nav-link-methode',
  linkAbout: 'nav-link-about',
  linkContact: 'nav-link-contact',
  ctaContact: 'nav-cta-contact',
  mobileToggle: 'nav-mobile-toggle',
};

export const HERO = {
  root: 'hero-section',
  title: 'hero-title',
  subtitle: 'hero-subtitle',
  ctaWhatsapp: 'hero-cta-whatsapp',
  ctaExpertises: 'hero-cta-expertises',
  ctaLinkedin: 'hero-cta-linkedin',
  proofStrip: 'hero-proof-strip',
};

export const SECTION = {
  valueProp: 'section-value-prop',
  expertises: 'section-expertises',
  cases: 'section-case-studies',
  methodology: 'section-methodology',
  figures: 'section-key-figures',
  insights: 'section-insights',
  about: 'section-about',
  testimonials: 'section-testimonials',
  contact: 'section-contact',
  footer: 'site-footer',
};

export const INSIGHTS = {
  card: 'insight-card',
  viewAll: 'insights-view-all',
  listPage: 'insights-list-page',
  detailPage: 'insight-detail-page',
  backToList: 'insight-back-to-list',
};

export const CONTACT = {
  form: 'contact-form',
  inputName: 'contact-input-name',
  inputEmail: 'contact-input-email',
  inputOrg: 'contact-input-organization',
  inputSubject: 'contact-input-subject',
  inputMessage: 'contact-input-message',
  submit: 'contact-submit',
  whatsapp: 'contact-whatsapp-btn',
  linkedin: 'contact-linkedin-btn',
};

export const FOOTER = {
  email: 'footer-email',
  phone: 'footer-phone',
  linkedin: 'footer-linkedin',
};
